module.exports = __webpack_public_path__ + "static/media/rearHouseNew.4f2dcda0.png";